var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Meeting',{attrs:{"meetId":_vm.$route.params.meetId,"username":_vm.username},on:{"~endMeet":function($event){return _vm.endMeet.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }